import { render } from "./MunicipalityInput.vue?vue&type=template&id=076544a8"
import script from "./MunicipalityInput.vue?vue&type=script&lang=js"
export * from "./MunicipalityInput.vue?vue&type=script&lang=js"

import "./MunicipalityInput.vue?vue&type=style&index=0&id=076544a8&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__